"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f596 = void 0;
exports.f596 = {
    "ɔ": [
        854
    ],
    "ɔl maa": [
        4591,
        4592
    ],
    "ɔl": [
        4591,
        4592
    ]
};
